<template>
  <div class="m-t-5">
    <b-row style="background:#b9b9b9; padding-left: 12px; padding-right:12px">
      <b-col class="p-sm-2 text-center" v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
      <b-col class="p-sm-2" style="padding-right: 0.25rem!important;" v-else>
        <Banner :link="banners.pos1[0].link" :img="banners.pos1[0].imagen.guid" />
      </b-col>
      <b-col class="p-sm-2 text-center" v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
      <b-col class="p-sm-2" style="padding-left: 0.25rem!important;" v-else>
        <Banner :link="banners.pos2[0].link" :img="banners.pos2[0].imagen.guid" />
      </b-col>
    </b-row>
    <b-row class="m-5 mb-3">
      <b-col>
        <h2 id="noticias">Últimas noticias</h2>
        <b-button
          :to="`/noticias/`"
          variant="secondary"
          shadow-sm
          style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
          class="shadow mt-3 mb-3"
        >Ver Todas</b-button>
      </b-col>
    </b-row>
    <PostsRow />
    <b-row class="row p5" style="background:rgb(244, 244, 244); margin-top:100px">
      <b-col>
        <div style="position: absolute;
   top: -125px;
    left: 25%;">
          <b-img
            class="d-none d-md-block"
            src="@/assets/images/nosotrosf.png"
            alt
            style="height: 900px;
    width: auto;
        filter: drop-shadow(55px 15px 25px #666);"
          />
        </div>
      </b-col>
      <b-col class="m-5 pt-5 pb-5" lg="6" md="6" sm="8">
        <h2 id="nosotros" style="margin-bottom:30px">Nosotros</h2>
        <p
          class="mid"
        >Los objetivos de nuestra organización son la planificación, organización y dirección de intercambios sociales y deportivos, dentro de la disciplina del tenis, con miras a que nuestros asociados puedan participar dentro de sanas competencias, donde se exalte la amistad y el intercambio deportivo dentro de ambientes seguros y agradables.</p>

        <p
          class="mid"
        >CTA nació con el propósito de organizar intercambios tenísticos de todos los niveles, dentro de los clubes recreacionales de Caracas, para de esta forma brindar la calidad, respeto y seguridad que merecen nuestros afiliados.</p>
      </b-col>
    </b-row>
    <b-row class="m-3 mb-3">
      <div class="pb-5 mt-5" style="width:100%">
        <h2 style="text-align:center">Clubes Miembros de CTA</h2>
      </div>

      <b-col class="club-box" lg="3" md="6" sm="6">
        <ul>
          <li>Altamira Tenis Club</li>
          <li>Caracas Country Club</li>
          <li>Caracas Racquet Club</li>
          <li>Caracas Sports Club</li>
          <li>Caracas Theater Club</li>
          <li>Centro Catalán</li>
        </ul>
      </b-col>
      <b-col class="club-box" lg="3" md="6" sm="6">
        <ul>
          <li>Centro Asturiano de Caracas</li>
          <li>Centro Deportivo Hebraica</li>
          <li>Centro Portugués</li>
          <li>Centro Ítalo Venezolano</li>
          <li>Círculo Militar</li>
          <li>Club Campestre Los Cortijos</li>
        </ul>
      </b-col>
      <b-col class="club-box" lg="3" md="6" sm="6">
        <ul>
          <li>Club Hípico de Caracas</li>
          <li>Club Miranda</li>
          <li>Club Puerto Azul</li>
          <li>Club Santa Paula</li>
          <li>Club Táchira</li>
          <li>Hermandad Gallega</li>
        </ul>
      </b-col>
      <b-col class="club-box" lg="3" md="6" sm="6">
        <ul>
          <li>Hogar Canario</li>
          <li>Izcaragua Country Club</li>
          <li>Lagunita Country Club</li>
          <li>Monteclaro Country Club</li>
          <li>Valle Arriba Athletic Club</li>
          <li>Valle Arriba Golf Club</li>
        </ul>
      </b-col>
    </b-row>
    <b-row class="mt-3 p-5" style="background:#EDF8FA;">
      <div style="width: 95%;
    margin: auto;">
        <h2 style="text-align:center" class="pb-5">Comité</h2>
        <div class="p-0">
          <JuntaCarousel />
        </div>
      </div>
    </b-row>
    <b-row style="background:#b9b9b9; padding-left: 12px; padding-right:12px">
      <div class="col text-center" v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <b-col class="p-sm-3" v-else>
        <Banner :link="banners.pos3[0].link" :img="banners.pos3[0].imagen.guid" />
      </b-col>
    </b-row>

    <Calendario />
    <Ranking id="ranking" />
  </div>
</template>

<script>
import axios from "axios";
import config from "../../public/data/config.json";
import PostsRow from "../components/PostsRow";
import JuntaCarousel from "../components/JuntaCarousel";
import Calendario from "../components/Calendario";
import Ranking from "../components/Ranking";
import Banner from "../components/Banner";
export default {
  data() {
    return {
      banners: { pos1: "", pos2: "", pos3: "", pos4: "" },
      loading: false
    };
  },
  async mounted() {
    if (this.$route.hash) {
      this.scrollToHash();
    }
    this.loading = true;
    try {
      const results = await axios.get(config.URL + "/ad");
      this.banners.pos1 = results.data.filter(obj => {
        return obj.posicion[0] === "home1";
      });
      this.banners.pos2 = results.data.filter(obj => {
        return obj.posicion[0] === "home2";
      });
      this.banners.pos3 = results.data.filter(obj => {
        return obj.posicion[0] === "home3";
      });
      this.banners.pos4 = results.data.filter(obj => {
        return obj.posicion[0] === "home4";
      });

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    scrollToHash() {
      var hash = this.$route.hash;
      this.$nextTick(() => {
        this.$scrollTo(hash, 0, { offset: 300 });
      });
    }
  },
  components: {
    PostsRow,
    JuntaCarousel,
    Calendario,
    Ranking,
    Banner
  },
  metaInfo: {
    title: "Latest Stories"
  }
};
</script>
<style scoped>
.club-box {
  border-left: 1px solid #aac90e;
}
.club-box ul {
  list-style-type: none;
}
.club-box ul li {
  margin-left: -30px;
}

.junta-pic {
  border-radius: 25px;
}

.circle-img {
  border-radius: 50%;
}
.mid {
  font-size: 19px;
  line-height: 1.4;
  margin-bottom: 45px;
}
.person-name {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 5px;
}
.person-position {
  font-size: 12px;
  font-weight: 400;
  color: gray;
  margin-top: 0px;
}
.centered-text {
  text-align: center;
}
.ranking-name {
  font-weight: 400;
  text-transform: uppercase;
  font-size: 2em;
}
.ranking-name span {
  font-weight: 600;
}
</style>